import React from 'react';
import { PropTypes } from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import './topbar.css';
import LayoutActions from '../../../../reducers/layoutRedux';
import NavTab from './NavTab';

const Topbar = ({layoutType}) => {
    
    const dispatch = useDispatch();
    const tab = useSelector(state => state.layout.dashboardTab);
    const unreadMessagesCount = useSelector(state => state.messages.unreadMessagesCount);
    
    const handleNavTabClick = (propertyName) => {
        dispatch(LayoutActions.setDashboardTab(propertyName || 'dashboard'));
    }

    return (
        <div className='workflow-topbar-container'>
            <NavTab
                layoutType={layoutType}
                propertyName="dashboard"
                text='Dashboard.labels.Dashboard'
                isSelected={tab === 'dashboard'}
                onClick={handleNavTabClick}
                showIndicator={false}
                indicatorValue={unreadMessagesCount}
            />
            <NavTab
                layoutType={layoutType}
                propertyName="messages"
                text='Dashboard.labels.Messages'
                isSelected={tab === 'messages'}
                onClick={handleNavTabClick}
                showIndicator={unreadMessagesCount > 0 && tab !== 'messages'}
                indicatorValue={unreadMessagesCount}
            />
            <NavTab
                layoutType={layoutType}
                propertyName="documents"
                text='Dashboard.labels.Documents'
                isSelected={tab === 'documents'}
                onClick={handleNavTabClick}
                showIndicator={false}
                indicatorValue={unreadMessagesCount}
            />
        </div>
    )
}

Topbar.propTypes = {
    layoutType: PropTypes.string.isRequired
}

export default Topbar
